<template>
  <apexchart
    :key="chartKey"
    height="350"
    :options="chartOptions"
    :series="filteredSeries"
  />
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    series: {
      type: Array,
      required: true
    },
    selectedEncounters: {
      type: Array,
      required: false
    },
    type: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      chartOptions: {
        chart: {
          type: this.type,
          height: 350,
        },
        colors: ['#008FFB', '#FEB019'],
        title: {
          text: this.title,
          align: 'left',
        },
        xaxis: {
          type: 'category',
        },
        yaxis: {
          labels: {
            formatter: (value) => `${value.toFixed(0)}`
          }
        },
      },
    }
  },
  watch: {
    type () {
      this.updateChrtOptions()
    }
  },
  mounted () {
    this.updateChrtOptions()
  },
  computed: {
    filteredSeries () {
      if (!this.selectedEncounters.length) {
        return this.series
      }

      const selected = this.selectedEncounters.map(String)

      return this.series.map(series => ({
        ...series,
        data: series.data.filter(item =>
          selected.includes(String(item.x))
        )
      }))
    },
    chartKey () {
      return this.selectedEncounters
        .map(String)
        .sort()
        .join('|')
    }
  },
  methods: {
    updateChrtOptions () {
      if (this.type === 'bar') {
        this.chartOptions = {
          ...this.chartOptions,
          yaxis: {
            min: 0,
            max: 100,
            labels: {
              formatter: (value) => `${value}%`
            }
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return (val || 0).toFixed(2) + '%'
              }
            }
          },
          dataLabels: {
            enabled: true,
            formatter: function (val) {
              return (val || 0).toFixed(0) + '%'
            },
            offsetY: 20,
            style: {
              fontSize: '10px',
              colors: ['#304758'],
            },
          },
        }
      } else {
        this.chartOptions = {
          ...this.chartOptions,
          yaxis: {
            labels: {
              formatter: (value) => `${value.toFixed(0)}`
            }
          }
        }
      }
    }
  }
}
</script>